import {getRequiredStyleTitle} from "@/pages/productClass/components/util.tsx";
import {Tooltip} from "antd";
import {QuestionCircleOutlined} from "@ant-design/icons";

export const config = {
  rowSelection: false,
  pagination: false,
  fieldControl: false,
  columns: [
    {
      title: 'SPU名称/SPU_ID',
      dataIndex: 'productName',
      width: 250,
      ellipsis: true,
      render: 'nameRender',
    },
    {
      title: '单位',
      dataIndex: ['unitInfo', 'unitName'],
      width: 120,
      ellipsis: true,
    },
    {
      title: getRequiredStyleTitle('数量'),
      dataIndex: 'size',
      width: 120,
      render: 'numRender',
    },
    {
      title: getRequiredStyleTitle('开始日期'),
      dataIndex: 'startDate',
      width: 160,
      render: 'startRender'
    },
    {
      title: '结束日期',
      dataIndex: 'endDate',
      width: 160,
      render: 'endRender'
    },
    {
      title: (<span>
          附图顺序
          <Tooltip title="通过填写数字指定子产品SPU图片附图给组合SPU图片的顺序，空则代表不附给组合">
            <QuestionCircleOutlined style={{ marginLeft: 4}} />
          </Tooltip>
        </span>),
      dataIndex: 'type',
      width: 160,
      render: 'sortNumRender'
    },
    {
      title: getRequiredStyleTitle('SKU包含类型'),
      dataIndex: 'selectType',
      width: 160,
      render: 'typeSelectRender'
    },
    {
      title: '操作',
      dataIndex: 'id',
      fixed: 'right',
      width: 160,
      render: 'actionRender'
    },
  ],
  footer: [
    {
      label: '添加SPU',
      type: 'primary',
      events: ['onClick:onAddSPU']
    }
  ]
}
